import React from 'react';
import {
  DataModelerSelectSchemaFieldKey,
  DataModelerSelectTableColumn,
} from '../DataModelerFieldDropdown';
import { dataModelTooltipOptions } from '../../../../components/KubitTooltip/globalTooltips';
import {
  CenteredDiv,
  JoinConditionDimSection,
  JoinConditionRow,
  StyledJoinConditionOperatorSelect,
  StyledJoinTypeSelect,
} from './DataModelerJoinUI';
import {
  FieldClass,
  ITableColumnFieldsFragment,
  JoinConditionOperator,
} from '../../../../utils/apollo/graphqlSchema';
import {
  JOIN_CONDITION_REL_OP_SELECT_OPTS,
  JOIN_TYPE_SELECT_OPTS,
  JoinTypeOption,
} from './utils';
import { UnreachableCaseError } from 'ts-essentials';
import { SquareRemoveButton } from '../../../../components/Button';

interface IProps {
  isEditMode: boolean;
  factViewKey: string;
  isSubject: boolean;
  setIsSubject: (isSubject: boolean) => void;
  switchToTemporal: (() => void) | null;
  factFieldKey: string | undefined;
  setFactFieldKey: (fieldKey: string, isSubject: boolean) => void;
  relOp: JoinConditionOperator;
  setRelOp: (newOp: JoinConditionOperator) => void;
  dimViewKey: string;
  dimTableKey: string;
  dimTableColumn: string | undefined;
  setDimTableColumn: (column: string, isSubject: boolean) => void;
  availableColumnsFromServer: ITableColumnFieldsFragment[];
  remove?: () => void;
  isLast: boolean;
}

const DataModelerEditJoinPair = ({
  isEditMode,
  isSubject,
  setIsSubject,
  switchToTemporal,
  factViewKey,
  factFieldKey,
  setFactFieldKey,
  relOp,
  setRelOp,
  dimViewKey,
  dimTableKey,
  dimTableColumn,
  setDimTableColumn,
  availableColumnsFromServer,
  remove,
  isLast,
}: IProps) => {
  const currentType: JoinTypeOption = isSubject ? 'Subject' : 'Field';

  const onSwitchType = (newValue: string) => {
    const newType = newValue as JoinTypeOption;
    switch (newType) {
      case 'Subject':
        setIsSubject(true);
        break;
      case 'Field':
        setIsSubject(false);
        break;
      case 'Temporal':
        switchToTemporal?.();
        break;
      default:
        throw new UnreachableCaseError(newType);
    }
  };
  const fileredOpts = !!switchToTemporal
    ? JOIN_TYPE_SELECT_OPTS
    : JOIN_TYPE_SELECT_OPTS.filter((option) => option.value !== 'Temporal');

  const handleSetFactFieldKey = (fieldKey: string) => {
    setFactFieldKey(fieldKey, isSubject);
  };

  const handleSetDimtableColumn = (tableColum: ITableColumnFieldsFragment) => {
    setDimTableColumn(tableColum.column, isSubject);
  };
  const factFieldIsError = !!dimTableColumn && !factFieldKey;
  const dimColumnIsError = !!factFieldKey && !dimTableColumn;

  return (
    <JoinConditionRow $isLast={isLast}>
      <div>
        <StyledJoinTypeSelect
          disabled={!isEditMode}
          options={fileredOpts}
          value={currentType}
          onChange={onSwitchType}
        />
      </div>
      <DataModelerSelectSchemaFieldKey
        isDisabled={!isEditMode}
        viewKey={factViewKey}
        fieldKey={factFieldKey}
        setFieldKey={handleSetFactFieldKey}
        placeholder={'Select Fact Field'}
        fieldClassFilter={isSubject ? [FieldClass.Subject] : undefined}
        isError={factFieldIsError}
      />
      <CenteredDiv>
        <StyledJoinConditionOperatorSelect
          options={JOIN_CONDITION_REL_OP_SELECT_OPTS}
          value={relOp}
          onChange={(newVal: string) =>
            setRelOp(newVal as JoinConditionOperator)
          }
        />
      </CenteredDiv>
      <JoinConditionDimSection>
        <DataModelerSelectTableColumn
          isDisabled={!isEditMode}
          viewKey={dimViewKey}
          tableKey={dimTableKey}
          availableColumnsFromServer={availableColumnsFromServer}
          columnName={dimTableColumn}
          setColumn={handleSetDimtableColumn}
          addFieldOnSetColumn={false}
          placeholder={'Select Dimension Column'}
          isError={dimColumnIsError}
        />
        {remove && isEditMode && (
          <SquareRemoveButton
            onClick={remove}
            content={dataModelTooltipOptions.removeJoinConditionIcon.content}
          />
        )}
      </JoinConditionDimSection>
    </JoinConditionRow>
  );
};

export default DataModelerEditJoinPair;
